import React from 'react'

export interface ContainerProps {
  children: React.JSX.Element
  className?: string
}
export function Container({ children, className }: ContainerProps) {
  return (
    <div className={`mx-auto w-full max-w-[970px] px-4 ${className ?? ''}`}>
      {children}
    </div>
  )
}
